<template>
  <div class="help-page">
    <h1>
      <b>[&nbsp;</b>
      <i>operator</i>
      <b>&nbsp;]&nbsp;</b>
      <i>Waiting for help…</i>
    </h1>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {};
</script>

<style lang="scss">
.help-page {
  position: absolute;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: black;
  color: #f1ece6;
  padding: 120px;
}
</style>
